import React from "react";
import { CommandmentItemProps } from "./CommandmentItem.props";
import { P } from "common/P/P";
import { ReactComponent as CheckIcon } from "common/assets/icons/check.svg";
import { ReactComponent as ClipIcon } from "common/assets/icons/Paperclip.svg";
import { Button } from "common/Button/Button";

const CommandmentItem: React.FC<CommandmentItemProps> = ({
	name,
	date,
	note,
	files,
	from,
	position,
	onUpdate,
	checked,
}) => {
	return (
		<div className="p-4 rounded-md shadow-md w-full max-w-[330px] grid grid-cols-1 gap-3">
			<div className="grid gap-2 pb-2 border-b grid-cols-maxTwo place-content-between place-items-center border-strokeColor">
				<P size="p3" type="medium">
					{name}
				</P>
				<CheckIcon
					onClick={() => {
						if (!checked) {
							onUpdate();
						}
					}}
					className={`${
						checked ? "fill-green-200 stroke-green-500" : ""
					} cursor-pointer`}
				/>
			</div>
			<div className="grid gap-2 p-2 border rounded-md grid-cols-maxTwo place-content-between place-items-center border-lowOpacity">
				<P size="t1" type="regular">
					Ýerine ýetirilmeli senesi:
				</P>
				<P size="t1" type="regular">
					{date}
				</P>
			</div>

			<div className="grid grid-cols-1 gap-2 p-2 border rounded-md border-lowOpacity">
				<P size="t1" type="regular">
					{note}
				</P>
			</div>

			<div className="grid gap-2 p-2 border rounded-md grid-cols-maxTwo place-content-between place-items-center border-lowOpacity">
				<div className="grid gap-2 grid-cols-maxTwo place-items-center">
					<ClipIcon />
					<P size="t1" type="regular">
						{files}
					</P>
				</div>
				<Button appearance="main" paddingX="px-3" paddingY="py-1">
					Ýüklemek
				</Button>
			</div>

			<div className="grid gap-1 p-2 grid-cols-maxTwo place-items-center">
				<P size="t1" type="medium" className="text-mainColor">
					{from}
				</P>
				<P size="t1" type="regular">
					{position}
				</P>
			</div>
		</div>
	);
};

export default CommandmentItem;
